import { filter } from 'lodash';
import PropTypes from 'prop-types';
import { sentenceCase } from 'change-case';
import { useState, useEffect, useCallback } from 'react';
import CryptoJS from 'crypto-js';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  tableCellClasses
} from '@mui/material';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
// components
import { useDispatch } from 'react-redux';
import { format } from 'date-fns';
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import SearchNotFound from '../../components/SearchNotFound';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../components/_dashboard/user';
import BrudCrumbs from '../../components/BreadCrumbs';
import { getIcon, JourneyIcon } from '../../vector/index';
import PageTitle from '../../components/PageHeading';
//
// import USERLIST from '../../_mocks_/user';
import { fDate } from '../../utils/formatTime';
import MasterToolbar from '../Master/MasterToolbar';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import usePayoutSelector from '../../store/Slice/Payout/PayoutSelector';
import { getNetworkList, getPLList } from '../../store/Slice/Payout/PayoutSlice';
import useDebounce from '../../utils/useDebounce';
import RevenueService from '../services/RevenueService';
import NetworkToolbar from './NetworkToolbar';
import { PayoutApi } from '../../utils/Apis';
import { downloadApiData, saveApiData } from '../../store/Slice/Global/GlobalSlice';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'referenceId', label: 'referenceId', alignRight: false },
  { id: 'fileNumber', label: 'fileNumber', alignRight: false },

  { id: 'date', label: 'date', alignRight: false },
  { id: 'description', label: 'description', alignRight: false },

  { id: 'income', label: 'income', alignRight: false },
  { id: 'expense', label: 'expense', alignRight: false },

  { id: 'balance', label: 'balance', alignRight: false },
  { id: 'tds', label: 'tds', alignRight: false },

  { id: 'gst', label: 'gst', alignRight: false },
  { id: 'status', label: 'status', alignRight: false },
  { id: 'remarks', label: 'remarks', alignRight: false }

  // { id: 'action', label: 'ACTION' }
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}
/**
 * Represents a book.
 * @constructor
 * @param {string} title - The title of the book.
 * @param {string} author - The author of the book.
 */
export default function PandL() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10000);

  const dispatch = useDispatch();
  const debouncedSearch = useDebounce(filterName, 1000);
  const { LoginData } = useLoginSelector();
  const { PayoutPLData } = usePayoutSelector();
  const [pageMenu, setPageMenu] = useState([]);
  const [filterState, setFilterState] = useState({
    typeId: null,
    isActive: null,
    cityId: null
  });

  const getPLListData = useCallback(() => {
    if (!LoginData?.userId) return;
    const credential = {
      userId: LoginData?.userId
    };
    dispatch(getPLList(credential));
  }, [LoginData]);

  useEffect(() => {
    getPLListData();
  }, [getPLListData]);

  // console.log('PayoutPLData2222', PayoutPLData);
  const PandLDataList = PayoutPLData?.summary?.transactions || [];

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = PandLDataList.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - PandLDataList.length) : 0;

  const filteredUsers = applySortFilter(PandLDataList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      fontSize: 13,
      fontWeight: 'bold',
      padding: '6px'
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 11,
      padding: '4px 6px'
    }
  }));

  const handleDownload = async (type) => {
    const credentials = {
      userId: LoginData?.userId,
      reporteeIds: selected
    };

    try {
      const result = await dispatch(downloadApiData(PayoutApi?.payoutNetworkDownload, credentials));

      if (result?.success && result?.data) {
        const fileName = `NetworkDataDownload_${format(new Date(), 'dd-MM-yyyy_HH-mm-ss')}.xlsx`;

        const url = window.URL.createObjectURL(result.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } else {
        console.error('Download failed:', result.error);
      }
    } catch (error) {
      console.error('Export error:', error);
    }
  };

  return (
    <Page title="Kpros by Kalolytic Solutions || My Transactions">
      <Box>
        <Card>
          <NetworkToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            parent="Customer"
            pageMenu={pageMenu}
            filterState={filterState}
            setFilterState={setFilterState}
            setFilterName={setFilterName}
            handleDownload={handleDownload}
          />

          <Scrollbar>
            <TableContainer
              sx={{
                minWidth: 800,
                height: '70vh',
                overflow: 'auto'
              }}
            >
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={PandLDataList.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  isCheckBox="true"
                />
                <TableBody>
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const {
                        referenceId,
                        fileNumber,
                        date,
                        description,
                        income,
                        expense,
                        balance,
                        tds,
                        gst,
                        status,
                        remarks
                      } = row;
                      const isItemSelected = selected.indexOf(referenceId) !== -1;

                      return (
                        <StyledTableRow
                          hover
                          key={referenceId}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleClick(event, referenceId)}
                            />
                          </TableCell>

                          <StyledTableCell align="left">{referenceId}</StyledTableCell>
                          <StyledTableCell align="left">{fileNumber}</StyledTableCell>
                          <StyledTableCell align="left">{date}</StyledTableCell>
                          <StyledTableCell align="left">{description}</StyledTableCell>
                          <StyledTableCell align="left">
                            {income && <Label color="success"> {income}</Label>}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {expense && <Label color="error"> {expense}</Label>}
                          </StyledTableCell>
                          <StyledTableCell align="left">{balance}</StyledTableCell>
                          <StyledTableCell align="left">{tds}</StyledTableCell>
                          <StyledTableCell align="left">{gst}</StyledTableCell>
                          <StyledTableCell align="left">{status}</StyledTableCell>
                          <StyledTableCell align="left">{remarks}</StyledTableCell>

                          {/* <StyledTableCell align="" width={80}>
                            <UserMoreMenu rowId={referenceId} parent="network" />
                          </StyledTableCell> */}
                        </StyledTableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <StyledTableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <StyledTableCell align="center" colSpan={12} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          {/* <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={USERLIST.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            /> */}
        </Card>
      </Box>
    </Page>
  );
}
